import { selectableListItemBehavior } from './selectableListItemBehavior';
import { basicListItemBehavior } from './basicListItemBehavior';
import { navigableListItemBehavior } from './navigableListItemBehavior';

/**
 * @description
 * Defines a behavior "BasicListItemBehavior" or "SelectableListItemBehavior" based on "selectable" property.
 */
export var listItemBehavior = function listItemBehavior(props) {
  return props.selectable ? selectableListItemBehavior(props) : props.navigable ? navigableListItemBehavior(props) : basicListItemBehavior(props);
};
//# sourceMappingURL=listItemBehavior.js.map
